import styled from 'styled-components'
import { TilesContainer } from 'components/dashboard/ActiveTabProgramCards/component.styles'

export const StyledTilesContainer = styled(TilesContainer)`
  button {
    min-width: 16rem;
    width: auto;
  }
`
